export const columnConfig = [
    {
        "cc": "bpp",
        "cp": 1,
        "hd": "BPP",
        "v": true,
        "cla": "left",
        "scc": "bpp"
    },
    {
        "cc": "plnt",
        "cp": 2,
        "hd": "Plant",
        "v": true,
        "cla": "left",
        "scc": "plnt"
    },
    {
        "cc": "oid",
        "cp": 3,
        "hd": "Order Id",
        "v": true,
        "cla": "left",
        "scc": "oid"
    },
    {
        "cc": "otyp",
        "cp": 4,
        "hd": "Order Type",
        "v": true,
        "cla": "left",
        "scc": "otyp"
    },
    {
        "cc": "li_id",
        "cp": 5,
        "hd": "Line Item Id",
        "v": true,
        "cla": "left",
        "scc": "li_id"
    },
    {
        "cc": "itmc",
        "cp": 6,
        "hd": "Item Code",
        "v": true,
        "cla": "left",
        "scc": "itmc"
    },
    {
        "cc": "itmd",
        "cp": 7,
        "hd": "Item Description",
        "v": true,
        "cla": "left",
        "scc": "itmd"
    },
    {
        "cc": "oqty",
        "cp": 8,
        "hd": "Order Quantity",
        "v": true,
        "cla": "left",
        "scc": "oqty"
    },
    {
        "cc": "mjr_r",
        "cp": 9,
        "hd": "Major Reason",
        "v": true,
        "cla": "left",
        "scc": "mjr_r"
    },
    {
        "cc": "min_r",
        "cp": 10,
        "hd": "Minor Reason",
        "v": true,
        "cla": "left",
        "scc": "min_r"
    },
    {
        "cc": "cc",
        "cp": 11,
        "hd": "Customer Code",
        "v": true,
        "cla": "left",
        "scc": "cc"
    },
    {
        "cc": "cn",
        "cp": 12,
        "hd": "Customer Name",
        "v": true,
        "cla": "left",
        "scc": "cn"
    },
]

export const reasonColConfig =  [
  { 
      "cc": "r",
      "cp": 2,
      "hd": "Major | Minor Reasons",
      "v": true,
      "cla": "left",
      "scc": "r"
  },
  { 
      "cc": "bo",
      "cp": 2,
      "hd": "Impacted orders - Black",
      "v": true,
      "cla": "left",
      "scc": "bo"
  },
  { 
    "cc": "ro",
    "cp": 3,
    "hd": "Impacted orders - Red",
    "v": true,
    "cla": "left",
    "scc": "ro"
},
]
